import { render, staticRenderFns } from "./consumerSalesSvg.vue?vue&type=template&id=4c8871f2"
import script from "./consumerSalesSvg.vue?vue&type=script&lang=js"
export * from "./consumerSalesSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports